//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpButton from '../button/Button.vue';

export default {
  name: 'DpTabs',
  components: {
    DpButton,
  },
  props: {
    disabledSections: { type: Array, default: () => [] },
    headerIcons: { type: Object, default: null },
    extraButton: { type: Object, default: null },
    centered: { type: Boolean, default: false },
    hideSingleTab: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
  },
  data() {
    return {
      activeSection: null,
      sections: [],
    };
  },
  computed: {
    visibleSections() {
      return this.sections.filter((s) => s.name === this.activeSection);
    },
    isHeaderVisible() {
      return !(this.hideSingleTab && this.sections.length === 1);
    },
  },
  mounted() {
    this.updateSections();

    let defaultSection = null;
    this.sections.forEach((s) => {
      if (s.default === true) {
        defaultSection = s.name;
      }
    });

    if (!defaultSection && this.sections.length > 0) {
      defaultSection = this.sections[0].name;
    }

    // Watch for changes in the $slots to pickup any new tabs that have been added/removed
    this.observer = new MutationObserver(this.updateSections);
    this.observer.observe(
      this.$refs.content,
      {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
      },
    );

    this.activeSection = defaultSection;
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    changeSection(section) {
      if (section.disabled) return;
      this.activeSection = section.name;
      this.$emit('change', section.name);
    },
    clickExtraButton() {
      if (this.extraButton.emit) {
        this.$emit(this.extraButton.emit);
        return;
      }
      this.$emit('click-extra-button');
    },
    updateSections() {
      const sections = [];
      Object.keys(this.$slots).forEach((k) => {
        const sectionObj = {
          name: k,
          disabled: this.disabledSections && this.disabledSections.includes(k),
        };

        if (this.headerIcons && this.headerIcons[k]) {
          sectionObj.icon = this.headerIcons[k];
        }

        sections.push(sectionObj);
      });
      this.sections = sections;
    },
  },
};
